import { Form } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { AppraisalSectionViewProps } from ".";


const PurposeFulfillment = (props: AppraisalSectionViewProps) => {

    const { t } = useTranslation();

    return (
        <div className="section-wrapper">
            {props.data?.purpose_fulfillment && props.data?.purpose_fulfillment.map((item, index) => (
                <React.Fragment key={index} >

                    <Form.Item
                        label={t("Appraisal.lbPurpose")}
                    >
                        <span>{item.title}</span>
                    </Form.Item>

                    <Form.Item
                        label={t("Appraisal.lbDescription")}>
                        <span>{item.description}</span>
                    </Form.Item>
                </React.Fragment>
            ))}
        </div>
    )
}

export default PurposeFulfillment;